import { useData } from "vike-react/useData";
import type { Data } from "./+data";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { BlogPostProvider } from "@/components/blog/BlogPostContext";
import { BlogBreadcrumb } from "@/components/blog/BlogBreadcrumb";
import { PostCard } from "@/components/blog/PostCard";
import { BlogStoresButton } from "@/components/blog/BlogEndCta";

const PILLAR_SLUG = "online-shopping-egypt-guide";

// Blog index (UI-SPEC section 1). Focal point is the featured pillar card (checker amendment 1).
// The rest are in data order (date desc): a publication order, not a ranking.
// Card clicks fire blog_link_clicked with surface blog_index through BlogAnchor (D-16).
export default function Page() {
  const { posts } = useData<Data>();
  const pillar = posts.find((post) => post.slug === PILLAR_SLUG);
  const rest = posts.filter((post) => post.slug !== PILLAR_SLUG);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-6 md:py-8 pb-16">
        <div className="max-w-5xl mx-auto font-arabic text-start">
          <BlogBreadcrumb />
          <h1 className="text-3xl leading-[1.4] font-bold text-gray-900">مدونة يتفرج</h1>
          <p className="text-base text-gray-600 mt-2 mb-8">
            إزاي تشتري أونلاين في مصر وانت مطمّن: أدلة عملية وأرقام من تقييمات مشترين حقيقيين.
          </p>

          <BlogPostProvider
            value={{ slug: "", snapshot: null, surface: "blog_index", firstDataBlockId: null }}
          >
            {posts.length === 0 ? (
              <section className="bg-white border border-gray-200 rounded-xl p-6">
                <h2 className="text-xl font-bold text-gray-900">لسه مفيش مقالات هنا</h2>
                <p className="text-base text-gray-600 mt-2">
                  بنكتب أول مقالات المدونة دلوقتي. لحد ما تنزل، دوّر على أي متجر وشوف تقييماته.
                </p>
                <BlogStoresButton />
              </section>
            ) : (
              <>
                {pillar && (
                  <div className="mb-6">
                    <PostCard post={pillar} featured />
                  </div>
                )}
                {rest.length > 0 && (
                  <div className="grid gap-6 md:grid-cols-2">
                    {rest.map((post) => (
                      <PostCard key={post.slug} post={post} />
                    ))}
                  </div>
                )}
              </>
            )}
          </BlogPostProvider>
        </div>
      </main>
      <Footer />
    </div>
  );
}
